module.exports = __webpack_public_path__ + "img/lang-13.7186d7b9.jpg";